<template>
  <div class="page">
    <div class="card">
      <!-- LOGO -->
      <div class="logo" style="flex-wrap:wrap;justify-content:center;">
        <div class="logo-flex">
          <img
            src="https://test.fotoncard.com/img/lg.e7a55f17.png"
            alt="Foton Card"
          />
          <h1>Foton Card</h1>
        </div>
        <p class="slogan">Secure Payment · Global Business</p>
      </div>

      <h2>Create Sub Account</h2>

      <!-- 表单 -->
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            v-model.trim="password"
            placeholder="Password"
          />
          <div class="error">{{ passwordError }}</div>
        </div>

        <div class="form-group">
          <label>Confirm Password</label>
          <input
            type="password"
            v-model.trim="confirmPassword"
            placeholder="Confirm Password"
          />
          <div class="error">{{ confirmError }}</div>
        </div>

        <button type="submit" :disabled="loading">
          <span v-if="loading" class="spinner"></span>
          <span>{{ loading ? 'Registering...' : 'Register' }}</span>
        </button>
      </form>

      <!-- 提示信息 -->
      <div
        v-if="message"
        class="message"
        :class="success ? 'success' : 'error-msg'"
      >
        {{ message }}
      </div>

      <!-- 社媒 -->
      <div class="media-box" style="margin-top: 15px;display:flex;justify-content:center;gap:15px;">
        <div class="mb-item">
          <a href="https://www.facebook.com/fotoncard" target="_blank">
            <img
              src="https://test.fotoncard.com/img/facebook2.13afd1e3.svg"
              width="23"
            />
          </a>
        </div>
        <div class="mb-item">
          <a
            target="_blank"
            href="https://www.instagram.com/fotoncard_official"
          >
            <img
              src="https://test.fotoncard.com/img/instagram2.29f5028e.svg"
              width="23"
            />
          </a>
        </div>
        <div class="mb-item">
          <a href="https://t.me/FotonCardCS" target="_blank">
            <img
              src="https://test.fotoncard.com/img/telegram2.808fa34a.svg"
              width="23"
            />
          </a>
        </div>
        <div class="mb-item">
          <a
            href="https://www.youtube.com/@FotonCard.Official"
            target="_blank"
          >
            <img
              src="https://test.fotoncard.com/img/youtube2.1fb74cff.svg"
              width="26"
            />
          </a>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <footer class="footer-box">
      Copyright © 2020 ~ 2026 Foton Card All rights reserved
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CreateSubAccount",

  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordError: "",
      confirmError: "",
      message: "",
      success: false,
      loading: false,
      auth: "",
      primary_uid: "",
    };
  },

  created() {
    // 从地址栏读取参数
    this.auth = this.$route.query.auth;
  this.primary_uid =
    this.$route.query.primary_uid || this.$route.query.primary;
    // const params = new URLSearchParams(window.location.search);
    // this.auth = params.get("auth");
    // this.primary_uid =
    //   params.get("primary_uid") || params.get("primary");
  },

  methods: {
    handleSubmit() {
      if (!this.password) {
        this.passwordError = "Required";
        this.confirmError = "Required";
        this.message = "";
        return;
      }

        this.passwordError = "";
        this.confirmError = "";
        this.message = "";

      if (this.password !== this.confirmPassword) {
        this.confirmError = "Passwords do not match";
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append("type", "register_subaccount");
      formData.append("pw", this.password);
    //   formData.append("auth", this.auth);
    //   formData.append("primary_uid", this.primary_uid);

      axios
        .post(`/request/user.php?auth=${this.auth}&primary_uid=${this.primary_uid}`, formData)
        .then((res) => {
          const data = res.data;
          if (data.code === 200) {
            this.success = true;
            this.message = "Registration successful";
            this.$router.replace('/pages/login');
          } else {
            this.success = false;
            this.message = data.message || "Registration failed";
          }
        })
        .catch(() => {
          this.success = false;
          this.message = "Network error, please try again later";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.page {
  min-height: 100vh;
  background: #f3f6f9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 14px;
  padding: 32px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
}

.logo {
  text-align: center;
  margin-bottom: 24px;
}

.logo-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo img {
  width: 45px;
  margin-right: 8px;
}

.logo h1 {
  font-size: 34px;
  margin: 0;
  font-weight: 800;
}

.slogan {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  background: linear-gradient(90deg, #71cd9d, #79b8c5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.form-group {
  margin-bottom: 18px;
}

label {
  font-size: 14px;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.error {
  font-size: 12px;
  color: #e74c3c;
  margin-top: 6px;
}

button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(90deg, #82edbc, #86e0d2);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

button:disabled {
  opacity: 0.7;
}

.message {
  margin-top: 16px;
  text-align: center;
}

.success {
  color: #2ecc71;
}

.error-msg {
  color: #e74c3c;
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.footer-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: center;
  font-size: 13px;
  color: #3c4b64;
}
</style>
